import React, { useState } from "react";
import axiosInstance from "../utils/axiosInstance";
import Notification from "./Notification";
import { Button, Field, Input, Modal, StrokeIcon } from "./ui";

function UploadModFileModal({ fileId, setRefreshData }) {
  const [showModal, setShowModal] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(null);
  const [modFile, setModFile] = useState(null);
  const [additionalInput, setAdditionalInput] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const handleFileChange = (event) => {
    setModFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (modFile) {
      try {
        setUploadStatus("Uploading...");

        const formData = new FormData();
        formData.append("file", modFile);
        formData.append("fileId", fileId);
        formData.append("notes", additionalInput);

        const response = await axiosInstance.post(
          `/files/${fileId}/upload-mod-file`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        await new Promise((resolve) => setTimeout(resolve, 2000));
        setShowNotification(true);
        setMessage("Uploaded successfully.");
        setShowModal(false);
        setAdditionalInput("");
        setUploadStatus("");
        setRefreshData(true);
      } catch (error) {
        setMessage("Upload failed. Please try again.");
        setIsError(true);
      }
    } else {
      setUploadStatus("Please select a file before uploading.");
    }
  };

  return (
    <div>
      <Button variant="ghost" onClick={() => setShowModal(true)} className="w-full">
        <StrokeIcon className="h-5 w-5">
          <path d="M12 21V9M7 12l5-5 5 5" />
          <path d="M5 3h14" />
        </StrokeIcon>
        Upload Modified File
      </Button>

      {showNotification && (
        <Notification
          setShowNotification={setShowNotification}
          message={message}
          isError={isError}
        />
      )}

      {showModal && (
        <Modal
          title="Upload Modified File"
          size="max-w-lg"
          onClose={() => setShowModal(false)}
          footer={
            <>
              <Button variant="ghost" size="sm" onClick={() => setShowModal(false)}>
                Cancel
              </Button>
              <Button size="sm" onClick={handleUpload}>
                Upload
              </Button>
            </>
          }
        >
          <div className="space-y-4">
            <Field label="Notes for the customer" hint="Shown on the file page as IMPORTANT.">
              <Input
                type="text"
                id="additionalInput"
                value={additionalInput || ""}
                onChange={(e) => setAdditionalInput(e.target.value)}
                placeholder="e.g. correct the checksum before writing"
              />
            </Field>

            <Field label="Mod file">
              <input
                type="file"
                id="modFileUpload"
                onChange={handleFileChange}
                className="block w-full cursor-pointer rounded-[12px] border border-gray-300 bg-white text-sm text-gray-600 file:mr-3 file:cursor-pointer file:rounded-l-[10px] file:border-0 file:bg-gray-100 file:px-4 file:py-2.5 file:text-sm file:font-semibold file:text-gray-700 hover:border-red-400/60 dark:border-[#3a3a3d] dark:bg-[#262628] dark:text-slate-300 dark:file:bg-[#303032] dark:file:text-slate-200"
              />
            </Field>

            {uploadStatus && (
              <p className="text-sm font-medium text-gray-500 dark:text-slate-400">{uploadStatus}</p>
            )}
          </div>
        </Modal>
      )}
    </div>
  );
}

export default UploadModFileModal;
